import React from 'react';
import './Card.css'

export const Card = (props) => {    
    return (
        <div className='card'>
            <div className='card__header'>
                <h2>{props.title}</h2>
            </div>
            <div className="card__body">
                {props.children}
            </div>
        </div>
    )
};


// WEBPACK FOOTER //
// ./src/components/content-container/card/Card.jsx